import type { ProjectsBatchEditContentProps } from "./projects-batch-edit-content.type";

import { ProjectsBatchAssignUsers } from "@/modules/projects/projects-batch-assign-users";
import SidePanelFormFooter from "@/modules/side-panel-form-footer";

export const ProjectsBatchEditContent = ({
  projects,
  property,
}: ProjectsBatchEditContentProps) => {
  if (property === "users") {
    return <ProjectsBatchAssignUsers projects={projects} />;
  }

  // default footer, with "cancel" button
  return <SidePanelFormFooter hideSubmit />;
};
